import { render } from "./AuthTemplate.vue?vue&type=template&id=bc9e480c&scoped=true"
import script from "./AuthTemplate.vue?vue&type=script&lang=js"
export * from "./AuthTemplate.vue?vue&type=script&lang=js"

import "./AuthTemplate.vue?vue&type=style&index=0&id=bc9e480c&lang=scss&scoped=true"

import exportComponent from "/var/www/application-mobile/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bc9e480c"]])

export default __exports__